import { mapGetters } from 'vuex';
import { USER_ROLES } from '@/store/modules/user';

export default {
  computed: {
    ...mapGetters([
      'user',
      'userRole',
      'providerType',
      'leadTotalCount',
      'allPoliciesTotalCount',
      'firstHub',
      'currentHub',
      'isOnboardingSimulated',
      'simulatedLeadCreated',
      'simulatedPolicyCreated',
      'isSalesHubOnboardingActive',
      'isServiceHubOnboardingActive',
    ]),
    isUserAdmin() {
      return this.userRole === USER_ROLES.ADMIN;
    },
    effectiveLeadCount() {
      return (this.isOnboardingSimulated && !this.simulatedLeadCreated) ? 0 : this.leadTotalCount;
    },
    effectivePolicyCount() {
      return (this.isOnboardingSimulated && !this.simulatedPolicyCreated) ? 0 : this.allPoliciesTotalCount;
    },
    isOnboardingActive() {
      return this.isSalesHubOnboardingActive || this.isServiceHubOnboardingActive;
    },
  },
};
